// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h3[data-v-08272ccd]{line-height:1.2em;margin-bottom:.3em}", ""]);
// Exports
module.exports = exports;
